import { SilverTigerSessions } from '@/types_cp/session/agent-session';
import { LobeSessionGroups, SessionGroupId } from '@/types_cp/session/session-group';

export * from './agent-session';
export * from './session-group';

export interface ChatSessionList {
  sessionGroups: LobeSessionGroups;
  sessions: SilverTigerSessions;
}

export interface UpdateSessionParams {
  group?: SessionGroupId;
  meta?: any;
  pinned?: boolean;
  updatedAt: Date;
}

export interface SessionRankItem {
  avatar: string | null;
  backgroundColor: string | null;
  count: number;
  id: string;
  title: string | null;
}
